import Index from './index.vue'
import ViewInvoice from './components/ViewInvoice.vue'

export default [
  {
    path: '/global/invoice',
    name: 'invoice',
    component: Index,
    title: 'Invoice',
    redirect: { name: 'view-invoiced' },
    children: [
      {
        path: ':id/view',
        name: 'view-invoice',
        component: ViewInvoice,
      },
    ],
  },
]
